import api from '../api/axios';

const getAll = (includeInactive = false) => {
  return api.get(`/rebate?includeInactive=${includeInactive}`);
};

const getById = (id) => {
  return api.get(`/rebate/${id}`);
};

const create = (data) => {
  return api.post('/rebate', data);
};

const update = (id, data) => {
  return api.patch(`/rebate/${id}`, data);
};

const remove = (id) => {
  return api.delete(`/rebate/${id}`);
};

const restore = (id) => {
  return api.get(`/rebate/${id}/restore`);
};

const reorder = (rebateIds) => {
  return api.post('/rebate/reorder', { rebateIds });
};

const rebateServices = {
  getAll,
  getById,
  create,
  update,
  remove,
  restore,
  reorder,
};

export default rebateServices;

